// removed by extract-text-webpack-plugin
module.exports = {"pitch":"Pitch__pitch___38ZFu","declined":"Pitch__declined___3GNEg","name":"Pitch__name___3cDnO","body":"Pitch__body___3BCox","header":"Pitch__header___1is2e","messages":"Pitch__messages___2hy2P","messagesText":"Pitch__messagesText___2tiz7","decline":"Pitch__decline___1ww-q","declinedOn":"Pitch__declinedOn___315ml","undo":"Pitch__undo___3Iyb7","details":"Pitch__details___2K-Zb","date":"Pitch__date___1sVMw","message":"Pitch__message___2xOJs","matches":"Pitch__matches___D1rK-"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/employer/projectInformation/components/candidates/Pitch.scss
// module id = 1953
// module chunks = 0